import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearFilter } from "../../redux/filter/action";

const Header = () => {
  const dispatch = useDispatch();
  const filters = useSelector((state) => state?.filters);
  const clearFilterHandler = () => {
    dispatch(clearFilter());
  };

  return (
    <div className="text-center">
      <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
        ALL BLOGS ARE HERE
      </h2>
      <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
        Blog in full web log or weblog, online journal where an individual,
        group, or corporation presents a record of activities, thoughts, or
        beliefs.
      </p>
      <div>
        {!!filters?.authorNames?.length &&
          filters?.authorNames.map((name) => (
            <p className="text-sm font-medium text-indigo-600">
              Search By Author:&nbsp;
              <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800">
                {name}
              </span>
            </p>
          ))}
      </div>
      <div className="py-1">
        {!!filters?.blogCategories?.length &&
          filters?.blogCategories.map((name) => (
            <p className="text-sm font-medium text-orange-600">
              Search By Categories:&nbsp;
              <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-orange-100 text-orange-800">
                {name}
              </span>
            </p>
          ))}
      </div>
      <div className="py-1">
        {(!!filters?.blogCategories?.length ||
          !!filters?.authorNames?.length) && (
          <div className="text-sm font-medium text-red-600">
            <button
              className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-800"
              type="button"
              style={{ cursor: "pointer" }}
              onClick={clearFilterHandler}
            >
              Clear Filter
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
